import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HecInputComponent } from "./hec-input/hec-input.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { PreventCutCopyPasteDirective } from "../../directives/preventCutCopyPaste";
import { OnlyNumericCharAllowedDirective } from "../../directives/onlyNumericChars";
import { OnlyAlphabetsAllowedDirective } from "../../directives/onlyAlphabets";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { SelectDropDownModule } from "ngx-select-dropdown";
import {
	MatDialogModule,
	MatButtonModule,
	MatIconModule,
	MatInputModule,
	MatNativeDateModule,
	MatTreeModule,
	MatMenuModule,
	MatExpansionModule,
	MatBottomSheetModule,
	MatButtonToggleModule,
	MatGridListModule,
	MatListModule,
	MatTooltipModule,
	MatTableModule,
	MatTabsModule,
	MatDividerModule,
	MatToolbarModule,
	MatCardModule,
	MatChipsModule,
	MatProgressBarModule,
	MatProgressSpinnerModule,
	MatSliderModule,
	MatPaginatorModule,
	MatSortModule,
	MatSidenavModule,
	MatSnackBarModule,
	MatStepperModule,
	MatAutocompleteModule,
	MatFormFieldModule,
	MatSlideToggleModule,
	MatDialogRef,
} from "@angular/material";
//import { PartialsModule } from '../../views/partials/partials.module'
import { MaxLengthNumberDirective } from "../../directives/numberMaxLength";
import { CheckpatternDirective } from "../../directives/checkpattern.directive";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { OnlyNumericCharWithoutDotAllowedDirective } from "../../directives/onlyNumericwithoutDot";
import { MaterialPreviewModule } from "../../views/partials/content/general/material-preview/material-preview.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { CoreModule } from "../../core/core.module";
import { OnlyAlphabetsWithSpacesAllowedDirective } from "../../directives/onlyAlphabetsWithSpaces";
import { Ng2ImgMaxModule } from "ng2-img-max";
import { PersonaDetailsFormComponent } from "./persona-details-form/persona-details-form.component";
import { ContactFormDetailComponent } from "./contact-form-detail/contact-form-detail.component";
import { EducationFormComponent } from "./education-form/education-form.component";
import { ErrorMsgComponentComponent } from "./error-msg-component/error-msg-component.component";
import { ProfilePictureUpdateComponent } from "./profile-picture-update/profile-picture-update.component";
import { QuestionnaireComponent } from "./modal/questionnaire/questionnaire.component";
import { UploadDocumentsComponent } from "./upload-documents/upload-documents.component";
import { ProgressComponent } from "./progress-component/progress-component.component";
import { WarningModalComponent } from "./modal/warning-modal/warning-modal.component";
import { DasUpdateCaseComponent } from "./das-update-case/das-update-case.component";
import { SuccessDasComponent } from "./modal/success-das/success-das.component";
import { SuccessSchedullingComponent } from "./modal/success-schedulling/success-schedulling.component";
import { FilterPipe } from "../../directives/searchFilter.directive";
import { MessagingService } from "./messaging.service";
import { AppLoaderComponent } from "./app-loader/app-loader.component";
import { DownloadSchedulingFormComponent } from "./download-scheduling-form/download-scheduling-form.component";
import { InvalidInputFocusDirective } from "../../directives/invalidInputFocusDirective";
//import { SpinnerModule } from "angular2-spinner/dist";
import { TimeAgoPipe } from "time-ago-pipe";
import { LegacyEducationComponent } from "./modal/legacy-education/legacy-education.component";
import { MatTableResponsiveComponent } from "./mat-table-responsive/mat-table-responsive.component";
import { WelcomeComponent } from "./modal/welcome/welcome.component";
import { NgxNumberSpinnerModule } from "ngx-number-spinner";
import { CommentsListComponent } from "./modal/comments-list/comments-list.component";
import { ApprovedDetailsComponent } from "./modal/approved-details/approved-details.component";
import { DocumentViewerComponent } from "./modal/document-viewer/document-viewer.component";
// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PdfViewerComponent } from "./modal/pdf-viewer/pdf-viewer.component";
import { VerifyChallanComponent } from "./modal/verify-challan/verify-challan.component";
import { DesIntrusctionsComponent } from "./modal/des-intrusctions/des-intrusctions.component";
import { LetterIssueComponent } from "./modal/letter-issue/letter-issue.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ForeignAttestationDetailComponent } from "./modal/foreign-attestation-detail/foreign-attestation-detail.component";
import { DownloadIssuedLettersComponent } from "./modal/download-issued-letters/download-issued-letters.component";
import { TranslateModule } from "@ngx-translate/core";
import { PopupComponent } from "./modal/popup/popup.component";
import { ConfirmationModalService } from "./modal/confimation-modal/confirmation-modal.service";
import { ConfimationModalComponent } from "./modal/confimation-modal/confimation-modal.component";
import { ThematicPanelInfoModalComponent } from "./modal/thematic-panel-info-modal/thematic-panel-info-modal.component";
import { ConditionalErrorsModalComponent } from "./modal/conditional-errors-modal/conditional-errors-modal.component";
import { ChangeOfRoleComponent } from "./modal/change-of-role/change-of-role.component";
import { AddMemberTypesComponent } from "./modal/add-member-types/add-member-types.component";
import { AddMemberByUserProfileComponent } from "./modal/add-member-by-user-profile/add-member-by-user-profile.component";
import { AddMemberByDisciplinaryPanelComponent } from "./modal/add-member-by-disciplinary-panel/add-member-by-disciplinary-panel.component";
import { AddMemberByInvitationComponent } from "./modal/add-member-by-invitation/add-member-by-invitation.component";
import { FormSubmWarningModalComponent } from "./modal/form-subm-warning-modal/form-subm-warning-modal.component";
import { InternationalPhoneNumberModule } from "ngx-international-phone-number";
import { ConditionalErrorsModalService } from "./modal/conditional-errors-modal/conditional-errors-modal.service";
import { FormSubmWarningModalService } from "./modal/form-subm-warning-modal/form-subm-warning-modal.service";
import { GlobalFilterPipe } from "../pipe-filters/global-filter";
import { ListFilterPipe } from "../pipe-filters/list-filter";
import { MaskPipe } from "../pipe-filters/masking";
import { SearchFilterPipe } from "../pipe-filters/search-filter.pipe";
import { FilterPipe2 } from "../pipe-filters/searchFilter.pipe";
import { FilterPipe1 } from "../pipe-filters/filter";
import { OnlyAlphabetsWithDotsAllowedDirective } from "../../directives/onlyAlphabetsWithDots";
import { DesAdminDecisionComponent } from "./modal/des-admin-decision/des-admin-decision.component";
import { UploadComponent } from "./modal/upload/upload.component";
import { DocumentListComponent } from "./modal/document-list/document-list.component";
import { AdmintaskListComponent } from "./admintask-list/admintask-list.component";
import { ThousandSuffixesPipe } from "../pipe-filters/thousad-filter";
import { TaskTableComponent } from "./task-table/task-table.component";
import { AgGridModule } from "ag-grid-angular";
import { ProvinceDetailsComponent } from "./modal/province-details/province-details.component";
import {
	adminButtons,
	hecAdminButtons,
} from "./task-table/ag-grid-button.component";
import { DocumentHandlerComponent } from "./document-handler/document-handler.component";
import { AttestationDegreeDetailsComponent } from "./attestation-degree-details/attestation-degree-details.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
// import { PublicationFormComponent } from  "./publication-form/publication-form.component";
import { PersonalDetailsAdminComponent } from "./admin-personal-details/admin-personal-details.component";
import { updateLetterComponent } from "./modal/update-letter/update-letter.component";
import { ExportFileComponent } from "./modal/export-file/export-file.component";
import { CourseraCommentComponent } from "./modal/coursera-comment/coursera-comment.component";
import { UploadDocsComponent } from "./modal/upload-docs/upload-docs.component";
import { PaymentMethod } from "./modal/payment-method/payment-method.component";
import { PublicDownloadIssuedLettersComponent } from "./modal/public-download-issued-letters/public-download-issued-letters.component";
import { EmailPopUpComponenet } from "./modal/email-pop-up/email-pop-up.component";
import { NgImageSliderModule } from "ng-image-slider";


// import { updateLetterComponent } from "./modal/update-letter/update-letter.component";
// import {
//   ChildMessageRenderer,
//   adminButtons
// } from './task-table/ag-grid-button.component';
@NgModule({
	declarations: [
		HecInputComponent,
		PreventCutCopyPasteDirective,
		OnlyNumericCharAllowedDirective,
		OnlyAlphabetsAllowedDirective,
		MaxLengthNumberDirective,
		OnlyAlphabetsWithDotsAllowedDirective,
		CheckpatternDirective,
		OnlyNumericCharWithoutDotAllowedDirective,
		FilterPipe,
		FilterPipe2,
		InvalidInputFocusDirective,
		OnlyAlphabetsWithSpacesAllowedDirective,
		PersonaDetailsFormComponent,
		ContactFormDetailComponent,
		EducationFormComponent,
		ErrorMsgComponentComponent,
		ProfilePictureUpdateComponent,
		QuestionnaireComponent,
		UploadDocumentsComponent,
		ProgressComponent,
		WarningModalComponent,
		DasUpdateCaseComponent,
		SuccessDasComponent,
		SuccessSchedullingComponent,
		AppLoaderComponent,
		DownloadSchedulingFormComponent,
		TimeAgoPipe,
		LegacyEducationComponent,
		MatTableResponsiveComponent,
		WelcomeComponent,
		CommentsListComponent,
		ApprovedDetailsComponent,
		DocumentViewerComponent,
		PdfViewerComponent,
		VerifyChallanComponent,
		DesIntrusctionsComponent,
		LetterIssueComponent,
		ForeignAttestationDetailComponent,
		DownloadIssuedLettersComponent,
		PopupComponent,
		ConfimationModalComponent,
		ThematicPanelInfoModalComponent,
		ConditionalErrorsModalComponent,
		ChangeOfRoleComponent,
		AddMemberTypesComponent,
		AddMemberByUserProfileComponent,
		AddMemberByInvitationComponent,
		AddMemberByDisciplinaryPanelComponent,
		FormSubmWarningModalComponent,
		GlobalFilterPipe,
		ListFilterPipe,
		FilterPipe1,
		ThousandSuffixesPipe,
		MaskPipe,
		SearchFilterPipe,
		DesAdminDecisionComponent,
		ExportFileComponent,
		UploadComponent,
		DocumentListComponent,
		AdmintaskListComponent,
		FilterPipe2,
		adminButtons,
		hecAdminButtons,
		ProvinceDetailsComponent,
		DocumentHandlerComponent,
		TaskTableComponent,
		AttestationDegreeDetailsComponent,
		PersonalDetailsAdminComponent,
		updateLetterComponent,
		CourseraCommentComponent,
		UploadDocsComponent,
		PaymentMethod,
		PublicDownloadIssuedLettersComponent,
		// EmailPopUpComponenet

		// adminButtons
	],
	imports: [
		NgImageSliderModule,
		CommonModule,
		CollapseModule,
		FormsModule,
		NgbModule,
		//  SpinnerModule,
		ReactiveFormsModule,
		ModalModule.forRoot(),
		TooltipModule.forRoot(),
		SelectDropDownModule,
		MatDialogModule,
		MatButtonModule,
		MatIconModule,
		MatInputModule,
		MatButtonModule,
		AngularEditorModule,
		MatDatepickerModule,
		MatSelectModule,
		MatCheckboxModule,
		MatRadioModule,
		MatButtonModule,
		MatCardModule,
		MatChipsModule,
		MatSelectModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatIconModule,
		MatSliderModule,
		MatPaginatorModule,
		MatSortModule,
		MatSidenavModule,
		MatSnackBarModule,
		MatStepperModule,
		MatToolbarModule,
		MatDividerModule,
		MatTabsModule,
		MatTableModule,
		MatTooltipModule,
		MatListModule,
		MatGridListModule,
		MatButtonToggleModule,
		MatBottomSheetModule,
		MatExpansionModule,
		MatMenuModule,
		MaterialPreviewModule,
		MatTreeModule,
		MatSelectModule,
		ReactiveFormsModule,
		MatRadioModule,
		MatIconModule,
		MatInputModule,
		MatDatepickerModule,
		MatProgressSpinnerModule,
		MatCheckboxModule,
		MatAutocompleteModule,
		MatNativeDateModule,
		MatFormFieldModule,
		MatInputModule,
		MatRadioModule,
		NgxMatSelectSearchModule,
		CoreModule,
		Ng2ImgMaxModule,
		NgxNumberSpinnerModule,
		// NgxExtendedPdfViewerModule,
		TranslateModule,
		MatSlideToggleModule,
		AgGridModule.withComponents([]),
		NgMultiSelectDropDownModule.forRoot(),
	],
	exports: [
		NgImageSliderModule,
		HecInputComponent,
		MatButtonModule,
		MatCheckboxModule,
		MatDatepickerModule,
		MatDialogModule,
		MatIconModule,
		MatInputModule,
		MatNativeDateModule,
		MatRadioModule,
		MatCardModule,
		MatChipsModule,
		MatSelectModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatIconModule,
		MatSliderModule,
		MatPaginatorModule,
		MatSortModule,
		MatSidenavModule,
		MatSnackBarModule,
		MatStepperModule,
		MatToolbarModule,
		MatDividerModule,
		MatTabsModule,
		MatTableModule,
		MatTooltipModule,
		MatListModule,
		MatGridListModule,
		MatButtonToggleModule,
		MatBottomSheetModule,
		MatExpansionModule,
		MatMenuModule,
		MaterialPreviewModule,
		MatTreeModule,
		MatSelectModule,
		ReactiveFormsModule,
		MatRadioModule,
		MatIconModule,
		MatInputModule,
		MatDatepickerModule,
		MatProgressSpinnerModule,
		MatCheckboxModule,
		MatAutocompleteModule,
		MatNativeDateModule,
		MatFormFieldModule,
		MatInputModule,
		MatRadioModule,
		PreventCutCopyPasteDirective,
		OnlyNumericCharAllowedDirective,
		OnlyAlphabetsAllowedDirective,
		MaxLengthNumberDirective,
		CheckpatternDirective,
		OnlyNumericCharWithoutDotAllowedDirective,
		InvalidInputFocusDirective,
		OnlyAlphabetsWithDotsAllowedDirective,
		NgxMatSelectSearchModule,
		Ng2ImgMaxModule,
		ContactFormDetailComponent,
		EducationFormComponent,
		ErrorMsgComponentComponent,
		QuestionnaireComponent,
		UploadDocumentsComponent,
		ProgressComponent,
		WarningModalComponent,
		DasUpdateCaseComponent,
		SuccessDasComponent,
		FilterPipe,
		AppLoaderComponent,
		ProfilePictureUpdateComponent,
		TimeAgoPipe,
		LegacyEducationComponent,
		MatTableResponsiveComponent,
		NgxNumberSpinnerModule,
		
		// NgxExtendedPdfViewerModule,
		InternationalPhoneNumberModule,
		GlobalFilterPipe,
		ListFilterPipe,
		SearchFilterPipe,
		MatSlideToggleModule,
		UploadComponent,
		DocumentListComponent,
		ThousandSuffixesPipe,
		FilterPipe2,
		PopupComponent,
		adminButtons,
		hecAdminButtons,
		ProvinceDetailsComponent,
		DocumentHandlerComponent,
		TaskTableComponent,
		AttestationDegreeDetailsComponent,
		NgMultiSelectDropDownModule,
		// PublicationFormComponent,
		PersonalDetailsAdminComponent,
		UploadDocsComponent,
		PaymentMethod,
		
	],
	entryComponents: [
		QuestionnaireComponent,
		WarningModalComponent,
		DasUpdateCaseComponent,
		SuccessDasComponent,
		SuccessSchedullingComponent,
		LegacyEducationComponent,
		WelcomeComponent,
		CommentsListComponent,
		ApprovedDetailsComponent,
		DocumentViewerComponent,
		PdfViewerComponent,
		VerifyChallanComponent,
		DesIntrusctionsComponent,
		LetterIssueComponent,
		ForeignAttestationDetailComponent,
		DownloadIssuedLettersComponent,
		PopupComponent,
		ConfimationModalComponent,
		ThematicPanelInfoModalComponent,
		ConditionalErrorsModalComponent,
		ChangeOfRoleComponent,
		AddMemberTypesComponent,
		AddMemberByUserProfileComponent,
		AddMemberByInvitationComponent,
		AddMemberByDisciplinaryPanelComponent,
		FormSubmWarningModalComponent,
		DesAdminDecisionComponent,
		ExportFileComponent,
		adminButtons,
		hecAdminButtons,
		ProvinceDetailsComponent,
		PersonalDetailsAdminComponent,
		updateLetterComponent,
		CourseraCommentComponent,
		PaymentMethod,
		PublicDownloadIssuedLettersComponent,
		
		// EmailPopUpComponenet,
		

		// adminButtons
	],
	providers: [
		ConfirmationModalService,
		ConditionalErrorsModalService,
		FormSubmWarningModalService,
	],
})
export class SharedModule {}
